import { storePagination } from '@/mixins/store'
import axios from '@axios'

const getInitialState = () => ({
  ...storePagination.state(),
  accessProfiles: [],
  allAccessProfiles: [],
  accesses: [],
  filters: { name: '', permission: null },
})

export default {
  namespaced: true,
  state: getInitialState(),
  getters: {
    // Lista de acessos (permissões) para o combo de filtro, no formato
    // Resource.ActionCode com rótulo amigável.
    accessOptions(state) {
      const options = []
      state.accesses.forEach(func => {
        ;(func.actions || []).forEach(action => {
          const permission = `${func.resource}.${action.code}`
          options.push({
            value: permission,
            label: `${permission} - ${func.name} > ${action.name}`,
          })
        })
      })
      return options.sort((a, b) => a.label.localeCompare(b.label))
    },
  },

  mutations: {
    ...storePagination.mutations,

    SET_ACCESS_PROFILES(state, accessProfiles) {
      state.accessProfiles = accessProfiles
    },
    SET_ACCESS_ALL_PROFILES(state, allAccessProfiles) {
      state.allAccessProfiles = allAccessProfiles
    },
    SET_ACCESSES(state, accesses) {
      state.accesses = accesses
    },
    SET_FILTERS(state, filters) {
      state.filters = filters
    },
  },

  actions: {
    ...storePagination.actions,

    async fetchAccessProfiles({ commit, state }) {
      const response = await axios.get('/api/accessProfiles', {
        params: {
          name: state.filters.name,
          permission: state.filters.permission,
          pageSize: state.paging.pageSize,
          pageIndex: state.paging.currentPage - 1,
        },
      })
      commit('SET_ACCESS_PROFILES', response.data.results)
      commit('SET_PAGING', {
        ...state.paging,
        rowCount: response.data.rowCount,
        rowsInCurrentPage: response.data.rowsInCurrentPage,
      })
    },
    async fetchallAccessProfiles({ commit }) {
      const response = await axios.get('/api/accessProfiles', {
        params: {
          pageSize: 0,
        },
      })
      commit('SET_ACCESS_ALL_PROFILES', response.data.results)
    },
    // Carrega as funcionalidades/ações para montar o combo de acessos do filtro.
    async fetchAccesses({ commit, state }) {
      if (state.accesses.length) return
      const response = await axios.get('/api/functionalities', {
        params: { pageSize: 0, pageIndex: 0 },
      })
      commit('SET_ACCESSES', response.data.results || [])
    },
    resetFilters({ commit }) {
      commit('SET_CURRENT_PAGE', 1)
      commit('SET_FILTERS', getInitialState().filters)
    },
  },
}
